import { useCallback, useEffect, useState } from 'react';

export const useFetchData = <T>(
  fetchFunction: () => Promise<T>,
  dependencies: any[] = [],
) => {
  const [state, setState] = useState<{
    loading: boolean;
    data: T | null;
    error: string | null;
  }>({
    loading: true,
    data: null,
    error: null,
  });

  const fetchData = useCallback(() => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    fetchFunction()
      .then((data) => {
        setState({ loading: false, data, error: null });
      })
      .catch((error) => {
        setState({
          loading: false,
          data: null,
          error: error.message || 'Error fetching data',
        });
      });
  }, [fetchFunction]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return { ...state, fetch: fetchData };
};
